"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var timeFormats = {
  TWELVE_HOUR: '12_hour',
  TWENTY_FOUR_HOUR: '24_hour'
};
var _default = timeFormats;
exports["default"] = _default;